import { createContext, useContext, useState } from "react";

const dict = {
  IT: {
    nav_overview: "Panoramica",
    nav_pricing: "Licenze PRO",
    nav_demo: "Paddock",
    nav_login: "Accedi",
    nav_register: "Registrati",
    hero_kicker: "OFFICIAL PADDOCK PLATFORM",
    hero_title: "TRASFORMA IL TUO RALLY IN UN'ESPERIENZA DIGITALE",
    hero_sub: "Crea il tuo Official Rally Paddock, coinvolgi concorrenti e fan, attiva sponsor e misura l'impatto digitale del tuo evento.",
    cta_buy_event: "ACQUISTA EVENT LICENSE",
    cta_start_pro: "AVVIA RALLY LOVE PRO",
    cta_contact: "CONTATTACI",
    cta_i_am_organizer: "SONO UN ORGANIZZATORE DI RALLY",
    love_rally: "LOVE RALLY.",
    live_rally: "LIVE RALLY.",
    play_rally: "PLAY RALLY.",
    philosophy: "RALLY LOVE RENDE IL RALLY REALE DIGITALE.",
    plan_event: "EVENT",
    plan_season: "SEASON",
    plan_unlimited: "UNLIMITED",
    per_event: "per evento",
    per_year: "per anno",
    activate_pro: "ATTIVA RALLY LOVE PRO",
    activate_pro_sub: "Il tuo rally è pronto. Attiva Rally Love PRO per pubblicare il tuo Official Paddock.",
    choose_license: "SCEGLI LA TUA LICENZA",
    license_active: "LA TUA LICENZA RALLY LOVE PRO È ATTIVA",
    welcome_pro: "BENVENUTO SU RALLY LOVE PRO",
    create_first_rally: "CREA IL TUO PRIMO RALLY",
    section_paddock: "Official Paddock",
    section_paddock_desc: "Un hub digitale dove piloti, navigatori, team, fan e sponsor vivono il rally in tempo reale: leaderboard, quiz, missioni sponsor, pronostici e premi.",
    section_b2c: "B2C — Community",
    section_b2b: "B2B — Organizzatori & Sponsor",
    section_b2c_desc: "Piloti, navigatori, team, fan. Il gaming genera engagement.",
    section_b2b_desc: "Organizzatori, sponsor, partner. Rally Love PRO genera ricavi.",
  },
  EN: {
    nav_overview: "Overview",
    nav_pricing: "PRO Pricing",
    nav_demo: "Paddock",
    nav_login: "Login",
    nav_register: "Register",
    hero_kicker: "OFFICIAL PADDOCK PLATFORM",
    hero_title: "TURN YOUR RALLY INTO A DIGITAL EXPERIENCE",
    hero_sub: "Create your Official Rally Paddock, engage competitors and fans, activate sponsors and measure the digital impact of your event.",
    cta_buy_event: "BUY EVENT LICENSE",
    cta_start_pro: "START RALLY LOVE PRO",
    cta_contact: "CONTACT US",
    cta_i_am_organizer: "SONO UN ORGANIZZATORE DI RALLY",
    love_rally: "LOVE RALLY.",
    live_rally: "LIVE RALLY.",
    play_rally: "PLAY RALLY.",
    philosophy: "RALLY LOVE RENDE IL RALLY REALE DIGITALE.",
    plan_event: "EVENT",
    plan_season: "SEASON",
    plan_unlimited: "UNLIMITED",
    per_event: "per event",
    per_year: "per year",
    activate_pro: "ACTIVATE RALLY LOVE PRO",
    activate_pro_sub: "Your rally is ready. Activate Rally Love PRO to publish your Official Paddock.",
    choose_license: "CHOOSE YOUR LICENSE",
    license_active: "YOUR RALLY LOVE PRO LICENSE IS ACTIVE",
    welcome_pro: "WELCOME TO RALLY LOVE PRO",
    create_first_rally: "CREATE YOUR FIRST RALLY",
    section_paddock: "Official Paddock",
    section_paddock_desc: "A digital hub where drivers, co-drivers, teams, fans and sponsors live the rally in real time: leaderboard, quizzes, sponsor missions, predictions and prizes.",
    section_b2c: "B2C — Community",
    section_b2b: "B2B — Organizers & Sponsors",
    section_b2c_desc: "Drivers, co-drivers, teams, fans. Gaming drives engagement.",
    section_b2b_desc: "Organizers, sponsors, partners. Rally Love PRO drives revenue.",
  }
};

const I18nCtx = createContext({ lang: "IT", setLang: () => {}, t: (k) => k });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("rl_lang") || "IT");
  const switchLang = (l) => { setLang(l); localStorage.setItem("rl_lang", l); };
  const t = (k) => (dict[lang] && dict[lang][k]) || dict.EN[k] || k;
  return <I18nCtx.Provider value={{ lang, setLang: switchLang, t }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
